var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMesaComercio40X40(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5998 17.9667C8.5998 17.2763 9.15945 16.7167 9.8498 16.7167H31.1498C31.8402 16.7167 32.3998 17.2763 32.3998 17.9667C32.3998 18.657 31.8402 19.2167 31.1498 19.2167H9.8498C9.15945 19.2167 8.5998 18.657 8.5998 17.9667Z",
    fill: "#42C67E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4998 16.7167C21.1902 16.7167 21.7498 17.2763 21.7498 17.9667V31.3334C21.7498 32.0237 21.1902 32.5834 20.4998 32.5834C19.8094 32.5834 19.2498 32.0237 19.2498 31.3334V17.9667C19.2498 17.2763 19.8094 16.7167 20.4998 16.7167Z",
    fill: "#42C67E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2831 31.3334C16.2831 30.643 16.8428 30.0834 17.5331 30.0834H23.4665C24.1568 30.0834 24.7165 30.643 24.7165 31.3334C24.7165 32.0237 24.1568 32.5834 23.4665 32.5834H17.5331C16.8428 32.5834 16.2831 32.0237 16.2831 31.3334Z",
    fill: "#42C67E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0498 7.41669C3.74016 7.41669 4.2998 7.97633 4.2998 8.66669V31.3334C4.2998 32.0237 3.74016 32.5834 3.0498 32.5834C2.35945 32.5834 1.7998 32.0237 1.7998 31.3334V8.66669C1.7998 7.97633 2.35945 7.41669 3.0498 7.41669Z",
    fill: "#42C67E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7998 22.9C1.7998 22.2097 2.35945 21.65 3.0498 21.65H10.5665C12.7115 21.65 14.5498 23.3159 14.5498 25.4834V31.3334C14.5498 32.0237 13.9902 32.5834 13.2998 32.5834C12.6094 32.5834 12.0498 32.0237 12.0498 31.3334V25.4834C12.0498 24.8174 11.4548 24.15 10.5665 24.15H3.0498C2.35945 24.15 1.7998 23.5904 1.7998 22.9Z",
    fill: "#42C67E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9498 7.41669C38.6402 7.41669 39.1998 7.97633 39.1998 8.66669V31.3334C39.1998 32.0237 38.6402 32.5834 37.9498 32.5834C37.2594 32.5834 36.6998 32.0237 36.6998 31.3334V8.66669C36.6998 7.97633 37.2594 7.41669 37.9498 7.41669Z",
    fill: "#42C67E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4498 25.4834C26.4498 23.3159 28.2881 21.65 30.4331 21.65H37.9498C38.6402 21.65 39.1998 22.2097 39.1998 22.9C39.1998 23.5904 38.6402 24.15 37.9498 24.15H30.4331C29.5448 24.15 28.9498 24.8174 28.9498 25.4834V31.3334C28.9498 32.0237 28.3902 32.5834 27.6998 32.5834C27.0094 32.5834 26.4498 32.0237 26.4498 31.3334V25.4834Z",
    fill: "#42C67E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6001 17.9665C8.6001 17.2761 9.15974 16.7165 9.8501 16.7165H31.1501C31.8405 16.7165 32.4001 17.2761 32.4001 17.9665C32.4001 18.6568 31.8405 19.2165 31.1501 19.2165H9.8501C9.15974 19.2165 8.6001 18.6568 8.6001 17.9665Z",
    fill: "#2664C7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2834 31.3332C16.2834 30.6428 16.8431 30.0832 17.5334 30.0832H23.4668C24.1571 30.0832 24.7168 30.6428 24.7168 31.3332C24.7168 32.0235 24.1571 32.5832 23.4668 32.5832H17.5334C16.8431 32.5832 16.2834 32.0235 16.2834 31.3332Z",
    fill: "#2664C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5001 16.7165C21.1905 16.7165 21.7501 17.2761 21.7501 17.9665V31.3332C21.7501 32.0235 21.1905 32.5832 20.5001 32.5832C19.8097 32.5832 19.2501 32.0235 19.2501 31.3332V17.9665C19.2501 17.2761 19.8097 16.7165 20.5001 16.7165Z",
    fill: "#2664C7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMesaComercio40X40);
export default __webpack_public_path__ + "static/media/LOGO_MESA_COMERCIO_40X40.1a58fcfa65d50271dc72626de81031ba.svg";
export { ForwardRef as ReactComponent };